import { Navigate, RouteObject } from "react-router";
import { ContractRoute } from "./[contractId]/contract-route";
import { ContractDataRoute } from "./[contractId]/data/contract-data-route";
import { ContractPricingRoute } from "./[contractId]/pricing/contract-pricing-route";
import { ContractScopeOfWorksRoute } from "./[contractId]/scope-of-works/contract-scope-of-works-route";
import { ContractFilesRoute } from "./[contractId]/files/contract-files-route";

export const omniOfferContractRoutes: RouteObject[] = [
  {
    path: "contracts/:contractId",
    element: <ContractRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" replace />,
      },
      {
        path: "data",
        element: <ContractDataRoute />,
      },
      {
        path: "pricing",
        element: <ContractPricingRoute />,
      },
      {
        path: "scope-of-works",
        element: <ContractScopeOfWorksRoute />,
      },
      {
        path: "files",
        element: <ContractFilesRoute />,
      },
    ],
  },
];
